import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Button from 'modules/common/components/Button';
import { Spinner } from 'modules/common/components';
// import {
//   SummaryItem,
//   SummaryTitle,
//   SummaryCount,
//   LoaderWrapper,
//   SummaryIcon
// } from '../styles';
import { colors } from 'modules/common/styles';
import {
  LoaderWrapper,
  SummaryCount,
  SummaryItem,
  SummaryTitle
} from '../styles/main';
const propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool
};

class DashboardTileTheme extends React.Component {
  renderSummary(sum) {
    return (
      <Col
        sm={3}
        key={Math.random()}
        style={{  }}
      >
        <SummaryItem>
          <i>{sum.icon}</i>
          {/* <SummaryIcon>{sum.icon}</SummaryIcon> */}
          <SummaryCount>{sum.count} </SummaryCount>{' '}
          {sum.isSecs && sum.isSecs === true && <span>{'sec'}</span>}
          <SummaryTitle>{sum.title}</SummaryTitle>
          {/* <div className="progress">
            <div className="progress-bar" role="progressbar"></div>
          </div> */}
        </SummaryItem>
      </Col>
    );
  }

  render() {
    const { data, loading } = this.props;

    if (loading) {
      return (
        <LoaderWrapper>
          <Spinner objective />
        </LoaderWrapper>
      );
    }

    return (
      <Row
        style={{
          // margin: '20px'
          // background: colors.colorPrimary,
          // color: colors.colorWhite
        }}
      >
        {data.map(detail => this.renderSummary(detail))}
      </Row>
    );
  }
}

DashboardTileTheme.propTypes = propTypes;

export default DashboardTileTheme;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/DashboardTileTheme.js